module.exports = __webpack_public_path__ + "static/media/image_case_zancuo.32ce470e.png";